export default __webpack_public_path__ + "static/wed-design-boring-ui-course@2x-79c53365d8b2b76d4f3bac64e5282e8f.png";